import React from 'react';
import rythmBazarImage from '../../../assets/projectsImage/rythmBazarImages/rythmBazar.jpg';
import rythmBazarImage2 from '../../../assets/projectsImage/rythmBazarImages/rythmBazar2.jpg';
import rythmBazarImage3 from '../../../assets/projectsImage/rythmBazarImages/rythmBazar3.jpg';
import rythmBazarImage4 from '../../../assets/projectsImage/rythmBazarImages/rythmBazar4.jpg';
import adminPanelImage from '../../../assets/projectsImage/rythmBazarImages/adminPanel.jpg';
import buyerPanelImage1 from '../../../assets/projectsImage/rythmBazarImages/buyerPanel.jpg';
import buyerPanelImage2 from '../../../assets/projectsImage/rythmBazarImages/buyerPanel2_cardPayment.jpg';
import sellerPanelImage1 from '../../../assets/projectsImage/rythmBazarImages/sellerPanel.jpg';
import sellerPanelImage2 from '../../../assets/projectsImage/rythmBazarImages/sellerPanel2.jpg';
import reactLogoImage from '../../../assets/technologyLogo/react.png';
import reactRouterDomLogoImage from '../../../assets/technologyLogo/reactRouterDom.png';
import firebaseLogoImage from '../../../assets/technologyLogo/firebase.png';
import tailwindLogoImage from '../../../assets/technologyLogo/tailwind-css.png';
import nodeLogoImage from '../../../assets/technologyLogo/node.png';
import expressLogoImage from '../../../assets/technologyLogo/express.png';
import mongoDBLogoImage from '../../../assets/technologyLogo/mongodb.jpg';
import jwtLogoImage from '../../../assets/technologyLogo/jwt.png';
import { PhotoProvider, PhotoView } from 'react-photo-view';

const RythmBazar = () => {
    return (
        <section className='mt-12'>
            <div className='md:mx-0 mx-5'>
                <h1 className='text-5xl font-bold text-center' style={{ color: '#65647C' }}>Project Name: Rythm Bazar Website</h1>
                <hr className="h-px bg-gray-300 border-0 dark:bg-gray-700 mt-5 mb-10"></hr>
            </div>
            {/* live link, github link */}
            <div className='flex justify-center items-center mb-20 md:mx-0 mx-5'>
                <a href='https://rythm-bazar.web.app/' target="_blank" rel="noopener noreferrer" type="button" className="w-40 text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br shadow-lg shadow-blue-500/50  font-medium rounded-lg md:text-base text-xs px-2 py-2.5 text-center md:mr-10 mr-5">Live Website</a>
                <a href='https://github.com/EhsanEIK/rythm-bazar-client' target="_blank" rel="noopener noreferrer" type="button" className="w-40 text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br shadow-lg shadow-green-500/50 font-medium rounded-lg md:text-base text-xs px-2 py-2.5 text-center md:mr-10 mr-5">Github Client</a>
                <a href='https://github.com/EhsanEIK/rythm-bazar-server' target="_blank" rel="noopener noreferrer" type="button" className="w-40 text-white bg-gradient-to-r from-cyan-400 via-cyan-500 to-cyan-600 hover:bg-gradient-to-br shadow-lg shadow-cyan-500/50 font-medium rounded-lg md:text-base text-xs px-2 py-2.5 text-center">Github Server</a>
            </div>

            <PhotoProvider speed={() => 700}
                easing={(type) => (type === 2 ? 'cubic-bezier(0.36, 0, 0.66, -0.56)' : 'cubic-bezier(0.34, 1.56, 0.64, 1)')}>
                <div className='flex md:flex-row flex-col justify-center items-center gap-x-20 md:gap-y-0 gap-y-10'>
                    <PhotoView key="01" src={rythmBazarImage}>
                        <img src={rythmBazarImage} alt="rythmBazarImage" className='w-56 h-auto border border-teal-500 rounded-lg p-1 hover:cursor-pointer' />
                    </PhotoView>
                    <div className='flex flex-col gap-y-10'>
                        <PhotoView key="02" src={rythmBazarImage2}>
                            <img src={rythmBazarImage2} alt="rythmBazarImage2" className='w-56 h-56 border border-teal-500 rounded-lg p-1 hover:cursor-pointer' />
                        </PhotoView>
                        <PhotoView key="03" src={rythmBazarImage3}>
                            <img src={rythmBazarImage3} alt="rythmBazarImage3" className='w-56 h-auto border border-teal-500 rounded-lg p-1 hover:cursor-pointer' />
                        </PhotoView>
                        <PhotoView key="04" src={rythmBazarImage4}>
                            <img src={rythmBazarImage4} alt="rythmBazarImage4" className='w-56 h-56 border border-teal-500 rounded-lg p-1 hover:cursor-pointer' />
                        </PhotoView>
                    </div>
                </div>
            </PhotoProvider>

            <PhotoProvider speed={() => 700}
                easing={(type) => (type === 2 ? 'cubic-bezier(0.36, 0, 0.66, -0.56)' : 'cubic-bezier(0.34, 1.56, 0.64, 1)')}>
                <div className='flex md:flex-row flex-col justify-center items-center gap-x-20 md:gap-y-0 gap-y-10 mt-14'>
                    <div>
                        <h4 className='text-2xl font-semibold mb-5'>Admin Dashboard</h4>
                        <PhotoView key="05" src={adminPanelImage}>
                            <img src={adminPanelImage} alt="adminPanelImage" className='w-56 h-56 border border-teal-500 rounded-lg p-1 hover:cursor-pointer' />
                        </PhotoView>
                    </div>
                    <div>
                        <h4 className='text-2xl font-semibold mb-5'>Seller Dashboard</h4>
                        <PhotoView key="06" src={sellerPanelImage1}>
                            <img src={sellerPanelImage1} alt="sellerPanelImage1" className='w-56 h-56 border border-teal-500 rounded-lg p-1 hover:cursor-pointer' />
                        </PhotoView>
                        <PhotoView key="07" src={sellerPanelImage2}>
                            <img src={sellerPanelImage2} alt="sellerPanelImage2" className='w-56 h-56 mt-10 border border-teal-500 rounded-lg p-1 hover:cursor-pointer' />
                        </PhotoView>
                    </div>
                    <div>
                        <h4 className='text-2xl font-semibold mb-5'>Buyer Dashboard</h4>
                        <PhotoView key="08" src={buyerPanelImage1}>
                            <img src={buyerPanelImage1} alt="buyerPanelImage1" className='w-56 h-56 border border-teal-500 rounded-lg p-1 hover:cursor-pointer' />
                        </PhotoView>
                        <PhotoView key="09" src={buyerPanelImage1}>
                            <img src={buyerPanelImage2} alt="buyerPanelImage2" className='w-56 h-56 mt-10 border border-teal-500 rounded-lg p-1 hover:cursor-pointer' />
                        </PhotoView>
                    </div>
                </div>
            </PhotoProvider>

            {/* Technology */}
            <div>
                <h1 className='text-4xl font-bold text-center mt-28' style={{ color: '#65647C' }}>Technology</h1>
                <hr className="h-px bg-gray-300 border-0 dark:bg-gray-700 mt-5 mb-10"></hr>
                {/* front-end */}
                <div>
                    <h3 className='bg-indigo-300 text-2xl font-bold italic text-center p-5 md:mx-0 mx-3 mt-5 mb-10'>Front-End</h3>
                    <div className='flex md:flex-row flex-col justify-center items-center gap-10'>
                        <img src={reactLogoImage} alt="reactLogoImage" className='w-60' />
                        <img src={reactRouterDomLogoImage} alt="reactRouterDomLogoImage" className='w-60' />
                        <img src={firebaseLogoImage} alt="firebaseLogoImage" className='w-60' />
                        <img src={tailwindLogoImage} alt="tailwindLogoImage" className='w-60' />
                    </div>
                </div>
                {/* back-end */}
                <div>
                    <h3 className='bg-indigo-300 text-2xl font-bold italic text-center p-5 md:mx-0 mx-3 mt-20 mb-10'>Back-End</h3>
                    <div className='flex md:flex-row flex-col justify-center items-center gap-10'>
                        <img src={nodeLogoImage} alt="nodeLogoImage" className='w-60' />
                        <img src={expressLogoImage} alt="expressLogoImage" className='w-60' />
                        <img src={mongoDBLogoImage} alt="mongoDBLogoImage" className='w-40' />
                        <img src={jwtLogoImage} alt="jwtLogoImage" className='w-48' />
                    </div>
                </div>
            </div>

            {/* Features */}
            <div>
                <h1 className='text-4xl font-bold text-center mt-28' style={{ color: '#65647C' }}>Features</h1>
                <hr className="h-px bg-gray-300 border-0 dark:bg-gray-700 mt-5 mb-10"></hr>
                <ul className='list-disc text-xl font-medium md:mx-20 mx-10'>
                    <li className='mt-5'>User can register new account with email & password. and can sign in via email & password and google account.</li>
                    <li className='mt-5'>There are 3types of user: Admin, Seller, Buyer.</li>
                    <li className='mt-5'>There are a dashboard which routes are different for different role of user.</li>
                    <li className='mt-5'>Buyer can booked any product and after that he can confirm the payment by using any VISA/MASTER/DEBIT/CREDIT card.</li>
                    <li className='mt-5'>Added JWT token for verifying authorized user and accessing credential content.</li>
                    <li className='mt-5'>Admin can see and delete any sellers and buyers. Also, admin can verified any seller.</li>
                    <li className='mt-5'>Without verified seller, the product can't sell.</li>
                    <li className='mt-5'>Buyer can report any product to the admin.</li>
                    <li className='mt-5'>After confirm the product to be advertised, then it will display in the website.</li>
                    <li className='mt-5'>Added pagination.</li>
                    <li className='mt-5'>Created api for read, create, edit and post and getting the data from client to sever and then send the data to the database. (Server Side)</li>
                    <li className='mt-5'>Created some middleware to verify the user is admin/seller/buyer. (Server Side)</li>
                    <li className='mt-5'>Added CORS so that the client side can access the server from different port. (Server Side)</li>
                    <li className='mt-5'>Connected to the database- MongoDB. (Server Side)</li>
                </ul>
            </div>
        </section >
    );
};

export default RythmBazar;